import { Menu, LogOut, Search } from "lucide-react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GoBackButton from "./GoBackButton";
// import NavbarCart from "../cart/NavbarCart";
// import NavbarScanner from "../cart/NavbarScanner";
import MobileDrawer from "./MobileDrawer";
import { useAuth } from "../../components/AuthContext";

export default function TopBar() {
  //const { role, setLoginStatus } = useAuth(); // role: "sales" | "admin"
  //const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  if (location.pathname === "/pos") return null;

  // const logout = () => {
  //   setLoginStatus(false);
  //   localStorage.removeItem("isLoggedIn");
  //   navigate("/login");
  // };

  return (
    <>
      <header className="bg-white border-b px-4 py-3 flex justify-between items-center">
        {/* LEFT */}
        <div className="flex items-center gap-3">
          <button className="md:hidden" onClick={() => setDrawerOpen(true)}>
            <Menu className="w-6 h-6" />
          </button>
          {/* <span className="font-semibold text-lg">POS</span> */}
          <span className="flex items-center">
            <img src="/logo512.png" alt="Logo" className="h-10 w-auto" />
            <span className="font-bold">HemAuntyPOS</span>
          </span>
        </div>

        {/* SALES PERSON ACTIONS
        {role === "sales" && (
          <div className="flex items-center gap-2">
            <div className="hidden md:block relative">
              <input
                placeholder="Search book..."
                className="pl-9 pr-3 py-2 border rounded-lg"
              />
              <Search className="absolute left-2 top-2.5 w-4 h-4 text-gray-400" />
            </div>
            <NavbarScanner />
            <NavbarCart />
          </div>
        )} */}

        <div className="topbar insert-0">
          <GoBackButton />
        </div>

        {/* LOGOUT */}
        {/* <button onClick={logout}>
          <LogOut className="w-5 h-5 text-gray-700" />
        </button> */}
      </header>

      {/* MOBILE MENU */}
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
